import { render, staticRenderFns } from "./HomeAiShare.vue?vue&type=template&id=2b80f84c&scoped=true"
import script from "./HomeAiShare.vue?vue&type=script&lang=js"
export * from "./HomeAiShare.vue?vue&type=script&lang=js"
import style0 from "./HomeAiShare.vue?vue&type=style&index=0&id=2b80f84c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b80f84c",
  null
  
)

export default component.exports